/* 
 * Playback brought in almost directly from Flash so please excuse the non-idiomatic code
 *
 */

(function (SG) {
  SG.registerModule('playback');
  SG.bind('initialize:after', function(graph) {
    graph.loopPlay = _.bind(graph.loopPlay, graph);
  });

  _.extend(SG.prototype, {
    playbackSpeed: 1.5,

    setPlaybackSpeed: function(speed) { this.playbackSpeed = speed; },
    
    highlightPointAtTime: function(time) {
      var pointsAround = this.pointsAroundX(time, 'time');
      var x = this.pointsAroundToX(pointsAround);
      var point = this.data()[pointsAround.closestI];
      this.highlightPointAtX(point, x);
      this.showPointDetails(point, x);
      this.trigger('highlight_at_position', pointsAround);
    },

    setPlaybackPercentage: function(pct) {
      var points = this.dataToRender();
      if(!this._playing && !this._paused) {
        this._paused = true;
      }
      var maxTime = points[points.length-1]['time'];
      if(!maxTime) maxTime = points[points.length-2]['time'];

      this._playHead = points[0]['time'] + pct * (maxTime - points[0]['time']) / 100.0;
      this.highlightPointAtTime(this._playHead);
    },
    
    play: function() {
      if(this._playing) return;
      var points = this.dataToRender();
      
      if(!this._playHead || !this._paused) this._playHead = points[0]['time'];
      this._playing = true;
      this._paused = false;
      this.unbindMouseInteractions();
      this.loopPlay();
    },
    
    isPlaying: function() { return this._playing; },
    isPaused: function() { return this._paused; },
    
    loopPlay: function() {
      if(!this._playing) return;
      
      var points = this.dataToRender();
      
      var maxTime = points[points.length-1]['time'];
      if(!maxTime) maxTime = points[points.length-2]['time'];
      if(this._playHead < maxTime) {
        this.highlightPointAtTime(this._playHead);
        this._playHead += this.playbackSpeed;
        setTimeout(this.loopPlay, 40);
      } else {
        this._playing = false;
      }
    },
    
    pause: function() {
      this._playing = false;
      this._paused = true;
    },
    
    stopPlayback: function() {
      this._playing = this._paused = false;
      this.bindMouseInteractions();
    }

  });
  SG.Playhead = function(data, uniqueId) {
    var points = data.points();
    this.uniqueId = uniqueId;
    this._data = data;
    this._points = points;
    this.firstTime = points[0].time;
    this.maxTime = points[points.length-1].time || points[points.length-2].time;
    this.duration = this.maxTime - this.firstTime;
  };
  SG.Playhead.prototype = {
    pointsAroundOffsetTime: function(time) {
      var absTime = this.firstTime + time;
      if(absTime <= this.maxTime) 
        return this._data.pointsAroundX(absTime, 'time');
      else {
        var ptsAround = this._data.pointsAroundX(this.maxTime, 'time');
        ptsAround.pastEnd = true;
        return ptsAround;
      }
    },
    points: function() { return this._points; }
  };
  SG.MultiTrackPlayhead = function(graph) {
    this.graph = graph;
    this._playheads = [];
    this._currentTime = 0;
    this.playbackSpeed = 1.6;
    this._playing = false;
    this._paused = false;
    _.bindAll(this, 'loopPlay');
  };
  SG.MultiTrackPlayhead.prototype = {
    addData: function(data) {
      this._playheads.push(new SG.Playhead(data, this._playheads.length));
      this._numPlayheads = this._playheads.length;
      return this._playheads.length-1;
    },
    play: function() {
      if(this._playing) return;
      this._playing = true;
      this._paused = false;
      this.updatePauseAtTime();
      this.loopPlay();
    },
    pause: function() {
      this._playing = false;
      this._paused = true;
    },
    stopPlayback: function() {
      this._playing = this._paused = false;
      this._currentTime = 0;
      _.each(this._playheads, function(playhead) {
        this.graph.removeMarker(playhead.uniqueId);
      }, this);
    },
    maxDuration: function() {
      if(!this._maxDuration) {
        this._maxDuration = _.reduce(this._playheads, function(memo, playhead) {
          var diff = playhead.maxTime - playhead.firstTime;
          return diff > memo ? diff : memo;
        }, 0);
      }
      return this._maxDuration;
    },
    setPlaybackPercentage: function(pct) {
      this._currentTime = Math.round(this.maxDuration() * pct/100.0);
      this.setTime(this._currentTime);
    },
    loopPlay: function() {
      if(!this._playing) return;
      var time = this._currentTime + this.playbackSpeed, 
          allDone;
      if(time > this.pauseAtTime) {
        allDone = true;
        time = this.pauseAtTime;
      }
      this._currentTime = time;
      this.setTime(time);
      if(allDone) {
        this._playing = false;
        $('#play_pause_btn').removeClass('playing');
      } else {
        setTimeout(this.loopPlay, 50);
      }
    },
    pauseOnAnyFinish: function(bool) {
      this._pauseOnAnyFinish = bool;
      this.updatePauseAtTime();
    },
    updatePauseAtTime: function() {
      if(this._pauseOnAnyFinish) {
        this.pauseAtTime = _.reduce(this._playheads, function(memo, playhead) {
          return (playhead.duration > this._currentTime && (!memo || memo > playhead.duration)) ? playhead.duration : memo; 
        }, null, this);
      } else {
        this.pauseAtTime = _.reduce(this._playheads, function(memo, playhead) {
          return (playhead.duration > this._currentTime && (!memo || memo < playhead.duration)) ? playhead.duration : memo; 
        }, null, this);
      }
    },
    setTime: function(time) {
      var playheads = this._playheads,
          ptsAround,
          largestReportedTime = 0;
      for(var i=0; i < this._numPlayheads; i++) {
        ptsAround = playheads[i].pointsAroundOffsetTime(time);
        var points = playheads[i].points(),
            lastPt = points[ptsAround.lowI],
            pt = points[ptsAround.highI],
          timeFromPlayhead = ptsAround.x - playheads[i].firstTime;
        if(timeFromPlayhead > largestReportedTime) largestReportedTime = timeFromPlayhead;

        // positioning marker on map requires points with lat/lng
        if(lastPt.point && pt.point) {
          var lat1 = lastPt.point.lat,
              lng1 = lastPt.point.lng,
              lat2 = pt.point.lat,
              lng2 = pt.point.lng,
              newLat = (lat2 - lat1) * ptsAround.pct + lat1,
              newLng = (lng2 - lng1) * ptsAround.pct + lng1;
          this.graph.showMarker(newLng, newLat, playheads[i].uniqueId);
        }

      }
      this.largestReportedTime = largestReportedTime;
      var pct = Math.round(100 * largestReportedTime / this.maxDuration());
      $("#elapsed_time_slider").slider('option', 'value', pct);
      $('#elapsed_time').html(rwgps.LabelMaker.durationLabel(Math.floor(largestReportedTime)));
    }
  };
})(SampleGraph);



// WEBPACK FOOTER //
// ./public/javascripts/sample_graph/sample_graph.playback.js